import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import "./MogrtGroupItem.css";

const DND_ITEM_TYPE = "ITEM";
const DND_GROUP_TYPE = "GROUP";

function IconBasedOnType(type) {
  switch (type) {
    case 5:
      return <i className="fa-light fa-arrows-up-down-left-right"></i>;
    case 2:
      return <i className="fa-regular fa-slider"></i>;
    case 9:
      return <i className="fa-light fa-arrows-maximize"></i>;
    case 4:
      return <i className="fa-solid fa-eye-dropper"></i>;
    case 1:
      return <i className="fa-sharp fa-regular fa-square-check"></i>;
    case 13:
      return <i className="fa-light fa-list-dropdown"></i>;
    case 6:
      return <i className="fa-regular fa-text-size"></i>;
    case 14:
      return <i className="fa-sharp fa-regular fa-image"></i>;
    case 3:
      return <i className="fa-regular fa-arrows-rotate"></i>;
    default:
      return <i className="fa-regular fa-circle"></i>;
  }
}

function convertToRGBA(value = "") {
  const values = value.split(",").map((num) => parseFloat(num));
  if (values.length < 4 || values.some((num) => Number.isNaN(num))) {
    return "rgba(0,0,0,1)";
  }
  const [r, g, b, a] = values;
  return `rgba(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(
    b * 255,
  )}, ${a})`;
}

const renderValue = (item) => {
  if (item.propertyType?.type === 4) {
    return (
      <div className="item__color" style={{ backgroundColor: convertToRGBA(item.value) }}></div>
    );
  }

  if (item.propertyType?.type === 6) {
    return <div className="mogrt_item__text">{item.value}</div>;
  }

  return <div className="mogrt-group__value">{item.value}</div>;
};

const LAYER_TYPE_LABELS = {
  controls: { text: "controls", className: "layer-label--controls" },
  media: { text: "Media", className: "layer-label--media" },
  text: { text: "text", className: "layer-label--text" },
  other: { text: "Global", className: "layer-label--other" },
};

const getLayerLabelInfo = (layerType) => {
  if (!layerType) return null;
  const key = String(layerType).toLowerCase();
  return LAYER_TYPE_LABELS[key] || null;
};

function MogrtGroupItem({
  item,
  id,
  moveItem,
  isSelected,
  onSelect,
  isInGroup,
  selectedIds = [],
}) {
  const ref = useRef(null);
  const layerLabelInfo = getLayerLabelInfo(item.layerType);

  const [, drop] = useDrop({
    accept: [DND_ITEM_TYPE, DND_GROUP_TYPE],
    hover(draggedItem, monitor) {
      if (!ref.current || draggedItem.id === item.id) return;
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;

      let position = "before";
      if (
        clientOffset.y >
        hoverBoundingRect.bottom - hoverBoundingRect.height / 3
      ) {
        position = "after";
      }

      moveItem(draggedItem.selectedIds || draggedItem.id, item.id, position);
      onSelect(draggedItem.id, false, false);
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: DND_ITEM_TYPE,
    item: {
      id: item.id,
      type: DND_ITEM_TYPE,
      selectedIds: isSelected ? selectedIds : undefined,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging() && monitor.getItem().id === item.id,
    }),
  });

  drag(drop(ref));

  return (
    <div className="template-editor__item-wrapper">
      <div
        ref={ref}
        onClick={(e) => {
          e.stopPropagation();
          onSelect(id, e.shiftKey, e.ctrlKey || e.metaKey);
        }}
        className={[
          "template-editor__item",
          "template-editor__item--leaf",
          isSelected ? "template-editor__item--selected" : "",
          isInGroup ? "template-editor__item--nested" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        style={{
          opacity: isDragging ? 0.5 : 1,
          backgroundColor: isSelected ? "#1d1d1d" : undefined,
        }}
      >
        <div className="template-editor__item-main template-editor__item-main--leaf">
          <span className="template-editor__drag-handle">
            <i className="fa-solid fa-grip-vertical"></i>
          </span>
          <span className="template-editor__item-icon template-editor__item-icon--control">
            {IconBasedOnType(item.propertyType?.type)}
          </span>
          <div className="template-editor__item-content">
            <div className="template-editor__item-name">{item.name}</div>
            {layerLabelInfo && (
              <span
                className={["layer-label", layerLabelInfo.className]
                  .filter(Boolean)
                  .join(" ")}
              >
                {layerLabelInfo.text}
              </span>
            )}
            {/* {renderValue(item)} */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MogrtGroupItem;
